var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH1 = function SvgH1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "currentColor",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.9189H5.5V7.41894H2V10.9189H1V2.91895H2V6.41894H5.5V2.91895H6.5V10.9189ZM10.5 4.91895V10.9189H9.5V6.02095L8.5 6.28894V5.25395L9.75 4.91895H10.5Z"
  })));
};
export default SvgH1;